import * as React from 'react';

// Utils
// Constants
// Actions, Models & Interfaces
// Components
import { Modal, Link } from '@toolkit/ui';

// Styles
import '../styles/HotelFacilities.scss';

type Props = {
  facilities: string[];
  label: string;
  overlayTitle: string;
};

const HotelFacilitiesAll: React.FC<Props> = ({ facilities, label, overlayTitle }) => {
  const [overlayOpen, setOverlayOpen] = React.useState<boolean>(false);

  const openOverlay = () => {
    setOverlayOpen(true);
  };

  return (
    <>
      <Link type="small" onClick={openOverlay}>
        {label}
      </Link>
      <Modal
        isOpen={overlayOpen}
        onClose={() => setOverlayOpen(false)}
        title={overlayTitle}
        classNames={{ modal: 'tcp-hotel-facilities-overlay lp-modal' }}>
        <ul className="tcp-hotel-facilities-list">
          {facilities.map((currFacility: string, idx: number) => (
            <li key={`${currFacility}-${idx}`}>
              <i className="material-symbols" aria-hidden="true">
                check
              </i>
              <span>{currFacility}</span>
            </li>
          ))}
        </ul>
      </Modal>
    </>
  );
};

export default HotelFacilitiesAll;
